export default __webpack_public_path__ + "images/logoPeterThomasRoth.b9d3e32a8e292c0213cb0ce92d883c54.svg"